<template>
    <div>
        <p @click="downloadPhoto" class="is-pointer">
            <span class="has-text-weight-bold">Respuesta:</span>
            {{ answer.fileName }}

            <Icon family="fa" name="fa-cloud-download-alt" />
        </p>
    </div>
</template>

<script>
const backendApiUrl = process.env.VUE_APP_BACKEND_API_URL;

export default {
    name: "photo-action-item",
    props: {
        action: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            answer: "",
        };
    },
    mounted() {
        this.answer = this.action.answer;
    },
    watch: {
        action: {
            deep: true,
            handler(action) {
                this.answer = action.answer;
            },
        },
    },
    methods: {
        downloadPhoto() {
            window.open(
                `${backendApiUrl}api/files/photo/${this.action.answer.photoId}/download`,
                "_blank"
            );
        },
    },
};
</script>